import React from "react";
import { useNavigate } from "react-router-dom";
import { ORDER_FLOW, statusLabel, useLang } from "../lib/i18n";
import { Check } from "lucide-react";

export const OrderTimeline = ({ status }) => {
  const { lang } = useLang();
  const idx = ORDER_FLOW.indexOf(status);
  const terminal = ["rifiutato", "annullato"].includes(status);
  return (
    <div className="space-y-0" data-testid="order-timeline">
      {ORDER_FLOW.map((s, i) => {
        const done = idx >= 0 && i < idx;
        const current = i === idx;
        return (
          <div key={s} className="flex items-start gap-3">
            <div className="flex flex-col items-center">
              <div className={`flex h-7 w-7 items-center justify-center rounded-full text-xs font-bold transition ${done ? "bg-emerald-600 text-white" : current ? "bg-blue-600 text-white ring-4 ring-blue-100" : "bg-slate-200 text-slate-400"}`}>
                {done ? <Check className="h-4 w-4" /> : i + 1}
              </div>
              {i < ORDER_FLOW.length - 1 && <div className={`h-6 w-0.5 ${done ? "bg-emerald-500" : "bg-slate-200"}`} />}
            </div>
            <div className={`pt-0.5 text-sm ${current ? "font-bold text-blue-700" : done ? "text-slate-700" : "text-slate-400"}`}>
              {statusLabel(s, lang)}
            </div>
          </div>
        );
      })}
      {terminal && (
        <div className="mt-2 rounded-lg bg-rose-50 px-3 py-2 text-sm font-semibold text-rose-700">
          {statusLabel(status, lang)}
        </div>
      )}
    </div>
  );
};
